import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translations
const resources = {
  en: {
    translation: {
      // General
      "language": "Language",
      "swedish": "Swedish",
      "english": "English",

      // CountdownTimer
      "timeUntilIftar": "Time until Iftar",
      "timeUntilTomorrowsIftar": "Time until tomorrow's Iftar",
      "timeUntil": "Time until",
      "nextPrayerTime": "Next prayer time is",
      "hours": "Hours",
      "minutes": "Minutes",
      "seconds": "Seconds",
      "fajr": "Fajr",
      "maghrib": "Maghrib",
      "iftarTimeToday": "Iftar idag",
      "iftarTimeTomorrow": "Iftar imorgon",

      // PrayerSchedule
      "prayerSchedule": "Prayer Time",
      "timesFor": "Times for",
      "couldNotFetchTimes": "Could not fetch times",
      "fetchingTimes": "Fetching times...",
      "next": "Next",

      // Prayer names
      "dhuhr": "Dhuhr",
      "asr": "Asr",
      "isha": "Isha",

      // App
      "loading": "Loading...",
      "notifications": "Notifications",
      "notificationsDisabled": "Notifications are disabled",
      "browserNotSupported": "Browser does not support notifications",
      "notificationPermission": "Notification permission",
      "prayerApp": "Salah Timekeeper",

      // Settings
      "settings": "Settings",
      "enableNotifications": "Enable notifications",
      "remindMeBeforeIftar": "Remind me {{minutes}} minutes before {{prayer}}",
      "soundEnabled": "Sound",
      "saveSettings": "Save settings",

      // Restaurants
      "restaurantsForIftar": "Restaurants for Halal Food",
      "buffet": "Buffet",
      "familyFriendly": "Family-friendly",
      "indian": "Indian",
      "vegetarian": "Vegetarian",
      "kebab": "Kebab",
      "palestinian": "Palestinian",
      "middleEastern": "Middle Eastern",
      "visitWebsite": "Visit website",
      "restaurantsOnTikTok": "Restaurants on TikTok",
      "restaurantsOnInstagram": "Restaurants on Instagram",

      // Restaurant descriptions
      "jalviDescription": "Restaurant with a varied menu and special Iftar offerings.",
      "anmolDescription": "Indian restaurant and bakery with Iftar specialties.",
      "folketsDescription": "Popular kebab restaurant with Iftar buffet.",
      "sweetoDescription": "Palestinian cuisine with a mix of sweet and savory dishes for Iftar.",
      "babDescription": "Middle Eastern restaurant with traditional Iftar dishes.",

      // In the English translation section:
      // LocationSelector
      "location": "Location",
      "chooseLocation": "Choose your location for accurate prayer times",
      "useMyLocationAutomatically": "Use my location automatically",
      "searchForLocation": "Search for a location...",
      "searching": "Searching...",
      "noResultsFound": "No results found",
      "update": "Update",
      "updating": "Updating...",
      "fetchingYourLocation": "Fetching your location...",
      "locationDataUsage": "Location data is only used to calculate prayer times",
      "searchForMosque": "Search for the nearest mosque...",
      "mosqueLocation": "Mosque location",
      "openInMaps": "Open in Google Maps",
      "searchingMosques": "Searching mosques...",
      "noMosquesFound": "No mosques found",

      // Cities
      "Stockholm, Sverige": "Stockholm, Sweden",
      "Göteborg, Sverige": "Gothenburg, Sweden",
      "Malmö, Sverige": "Malmö, Sweden",
      "Uppsala, Sverige": "Uppsala, Sweden",
      "Västerås, Sverige": "Västerås, Sweden",
      "Örebro, Sverige": "Örebro, Sweden",
      "Linköping, Sverige": "Linköping, Sweden",
      "Helsingborg, Sverige": "Helsingborg, Sweden",
      "Jönköping, Sverige": "Jönköping, Sweden",
      "Norrköping, Sverige": "Norrköping, Sweden",

      // Footer translations
      "iftarTimekeeper": "Salah Timekeeper",
      "prayerTimesCalculatedAccordingTo": "Prayer times are retrieved from",
      "method": "method",
      "isnaMethod": "islamiskaforbundet.se",
      "developedBy": "Developed by Azmir AB",

      // Iftar Modal translations
      "iftarTimeNow": "It's time for Iftar!",
      "acceptFastMessage": "May Allah accept your fast and your prayers.",
      "iftarDua": "Allahumma laka sumtu wa ala rizqika aftartu.",
      "iftarDuaTranslation": "\"O Allah, for You I have fasted and with Your provision I break my fast.\"",
      "close": "Close",

      // Prayer Guide
      "prayerGuide": "Prayer Instruction",
      "prayerGuideDescription": "Instructions for performing Wudu and prayer correctly.",
      "downloadPrayerGuide": "Download Prayer Guide",
      "viewPrayerGuide": "View Prayer Instructions",
      "prayerGuideTitle": "Islamic Prayer Guide 2024",
      "prayerGuideFullDescription": "This comprehensive guide provides detailed instructions on how to perform Wudu (ablution) and prayers according to Islamic tradition. Perfect for both beginners and those looking to refine their practice.",
      "prayerBookCopyright": "© 2024 Islam.nu. All rights reserved.",
      "back": "Back",
      "iosPdfMessage": "For better viewing on mobile devices, please open the PDF directly:",
      "openPdf": "Open PDF",

      // Prayer Source
      "prayerSource": "Prayer Time Source",
      "sourceIslamiska": "Islamiska förbundet",
      "sourceIslamiskDesc": "islamiskaforbundet.se",
      "sourceVaktija": "Bosnian Islamic Community",
      "sourceVaktijaDesc": "vaktija.eu",
      "sourceAladhan": "Aladhan (Calculated)",
      "sourceAladhanDesc": "International calculation",
      "prayerSourceHint": "Choose which source to use for prayer times. The selection is saved automatically.",
    }
  },
  sv: {
    translation: {
      // General
      "language": "Språk",
      "swedish": "Svenska",
      "english": "Engelska",

      // CountdownTimer
      "timeUntilIftar": "Tid till Salah",
      "timeUntilTomorrowsIftar": "Tid till morgondagens Iftar",
      "timeUntil": "Tid till",
      "nextPrayerTime": "Nästa bön:",
      "hours": "Timmar",
      "minutes": "Minuter",
      "seconds": "Sekunder",
      "fajr": "Fajr",
      "maghrib": "Maghrib",
      "iftarTimeToday": "Iftar idag",
      "iftarTimeTomorrow": "Iftar imorgon",

      // PrayerSchedule
      "prayerSchedule": "Bönetider",
      "timesFor": "Tider för",
      "couldNotFetchTimes": "Kunde inte hämta tider",
      "fetchingTimes": "Hämtar tider...",
      "next": "Nästa",

      // Prayer names
      "dhuhr": "Dhuhr",
      "asr": "Asr",
      "isha": "Isha",

      // App
      "loading": "Laddar...",
      "notifications": "Notifikationer",
      "notificationsDisabled": "Notifikationer är inaktiverade",
      "browserNotSupported": "Webbläsaren stöder inte notifikationer",
      "notificationPermission": "Behörighet för notifikationer",
      "prayerApp": "Salah Tidsspårare",

      // Settings
      "settings": "Inställningar",
      "enableNotifications": "Aktivera notifikationer",
      "remindMeBeforeIftar": "Påminn mig {{minutes}} minuter innan {{prayer}}",
      "soundEnabled": "Ljud",
      "saveSettings": "Spara inställningar",

      // Restaurants
      "restaurantsForIftar": "Restauranger för Halal mat",
      "buffet": "Buffé",
      "familyFriendly": "Familjevänlig",
      "indian": "Indisk",
      "vegetarian": "Sötsaker",
      "kebab": "Kebab",
      "palestinian": "Palestinsk",
      "middleEastern": "Mellanöstern",
      "visitWebsite": "Besök webbplats",
      "restaurantsOnTikTok": "Restauranger på TikTok",
      "restaurantsOnInstagram": "Restauranger på Instagram",

      // Restaurant descriptions
      "jalviDescription": "Restaurang med en varierad meny och speciella Iftar-erbjudanden.",
      "anmolDescription": "Indisk restaurang och konditori med Iftar-specialiteter.",
      "folketsDescription": "Populär kebabrestaurang med Iftar-buffé.",
      "sweetoDescription": "Det palestinska köket med en blandning av söta och salta rätter för Iftar.",
      "babDescription": "Mellanöstern-restaurang med traditionella Iftar-rätter.",

      // In the English translation section:
      // LocationSelector
      "location": "Plats",
      "chooseLocation": "Välj din plats för att få korrekta bönetider",
      "useMyLocationAutomatically": "Använd min plats automatiskt",
      "searchForLocation": "Sök efter en plats...",
      "searching": "Searching...",
      "noResultsFound": "No results found",
      "update": "Update",
      "updating": "Updating...",
      "fetchingYourLocation": "Fetching your location...",
      "locationDataUsage": "Platsdata används endast för att beräkna bönetider",
      "searchForMosque": "Sök efter närmaste moske...",
      "mosqueLocation": "Moskéns plats",
      "openInMaps": "Öppna i Google Maps",
      "searchingMosques": "Söker moskéer...",
      "noMosquesFound": "Inga moskéer hittades",

      // Cities
      "Stockholm, Sverige": "Stockholm, Sverige",
      "Göteborg, Sverige": "Göteborg, Sverige",
      "Malmö, Sverige": "Malmö, Sverige",
      "Uppsala, Sverige": "Uppsala, Sverige",
      "Västerås, Sverige": "Västerås, Sverige",
      "Örebro, Sverige": "Örebro, Sverige",
      "Linköping, Sverige": "Linköping, Sverige",
      "Helsingborg, Sverige": "Helsingborg, Sverige",
      "Jönköping, Sverige": "Jönköping, Sverige",
      "Norrköping, Sverige": "Norrköping, Sverige",

      // Footer translations
      "iftarTimekeeper": "Salah Tidsspårare",
      "prayerTimesCalculatedAccordingTo": "Bönetider hämtas från",
      "method": "metod",
      "isnaMethod": "islamiskaforbundet.se",
      "developedBy": "Utvecklad av Azmir AB",

      // Iftar Modal translations
      "iftarTimeNow": "Det är dags för Iftar!",
      "acceptFastMessage": "Må Allah acceptera din fasta och dina böner.",
      "iftarDua": "Allahumma laka sumtu wa ala rizqika aftartu.",
      "iftarDuaTranslation": "\"O Allah, för Dig har jag fastat och med Din försörjning bryter jag min fasta.\"",
      "close": "Stäng",

      // Prayer Guide
      "prayerGuide": "Böneinstruktion",
      "prayerGuideDescription": "Instruktioner för att utföra Wudû och bön på ett korrekt sätt.",
      "downloadPrayerGuide": "Ladda ner bönebok",
      "viewPrayerGuide": "Visa böneinstruktioner",
      "prayerGuideTitle": "Islamisk Bönebok 2024",
      "prayerGuideFullDescription": "Denna omfattande guide ger detaljerade instruktioner om hur man utför Wudû (tvagning) och böner enligt islamisk tradition. Perfekt för både nybörjare och de som vill förfina sin praktik.",
      "prayerBookCopyright": "© 2024 Islam.nu. Alla rättigheter förbehållna.",
      "back": "Tillbaka",
      "iosPdfMessage": "För bättre visning på mobila enheter, vänligen öppna PDF direkt:",
      "openPdf": "Öppna PDF",

      // Prayer Source
      "prayerSource": "Bönetidskälla",
      "sourceIslamiska": "Islamiska förbundet",
      "sourceIslamiskDesc": "islamiskaforbundet.se",
      "sourceVaktija": "Bosniska Islamska Gemenskapen",
      "sourceVaktijaDesc": "vaktija.eu",
      "sourceAladhan": "Aladhan (Beräknad)",
      "sourceAladhanDesc": "Internationell beräkning",
      "prayerSourceHint": "Välj vilken källa som ska användas för bönetider. Valet sparas automatiskt.",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'sv',
    lng: 'sv', // Add this line to force Swedish as default
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    }
  });

export default i18n;